import styles from './SocialLogin.module.scss'

export default function SocialLogin({ provider, callback }) {
  const { id, name } = provider

  const getName = () => {
    if (id === 'google') {
      return 'Jatka Googlen kautta'
    }

    if (id === 'facebook') {
      return 'Jatka Facebookin kautta'
    }

    return name
  }

  return (
    <div className={styles.login}>
      <button
        className="btn btn--secondary btn--with-icon"
        key={provider.id}
        onClick={() => callback()}
      >
        <img
          src={`/img/social/${id}-black.svg`}
          width="30"
          height="30"
          role="presentation"
          alt={`${name} logo`}
          loading="lazy"
        />
        {getName()}
      </button>
    </div>
  )
}
